var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.totalPages > 1 || _vm.changed
    ? _c("div", { staticClass: "Pagination" }, [
        _c(
          "div",
          { staticClass: "Pagination--buttons" },
          [
            _c(
              "div",
              {
                class: [
                  "Pagination--buttons-btn",
                  _vm.pageNumber < 1 ? "controls-disabled" : "controls-active"
                ],
                on: { click: _vm.openPrevious }
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("keyboard_arrow_left")
                ])
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.pages, function(page, index) {
              return _c(
                "div",
                {
                  key: index,
                  class: [
                    "Pagination--buttons-btn",
                    {
                      "active-btn": page === _vm.pageNumber + 1,
                      "cursor-pointer": Number.isInteger(page)
                    }
                  ],
                  on: {
                    click: function($event) {
                      return _vm.openPageItem(page - 1)
                    }
                  }
                },
                [_vm._v("\n            " + _vm._s(page) + "\n        ")]
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                class: [
                  "Pagination--buttons-btn",
                  _vm.pageNumber >= _vm.totalPages - 1
                    ? "controls-disabled"
                    : "controls-active"
                ],
                on: { click: _vm.openNext }
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("keyboard_arrow_right")
                ])
              ]
            )
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column" }, [
          _c(
            "div",
            { staticClass: "Pagination--control" },
            [
              _c("label", [_vm._v("Show:")]),
              _vm._v(" "),
              _c("select-box", {
                staticClass: "Pagination--control-el",
                attrs: {
                  border: "none",
                  height: "40px",
                  "border-radius": "8px",
                  "data-list": _vm.pageSizeList,
                  "default-value": _vm.pageSize,
                  required: false,
                  "is-default": false
                },
                on: { selected: _vm.changeSize }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "page" } }, [_vm._v("Go to page:")]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "numeric|min_value:1|max_value:" + _vm.totalPages,
                      expression:
                        "`numeric|min_value:1|max_value:${totalPages}`"
                    }
                  ],
                  ref: "pageNumber",
                  staticClass: "Pagination--control-el",
                  attrs: { name: "page", id: "page", type: "number" },
                  on: { input: _vm.changePageNumber }
                })
              ]),
              _vm._v(" "),
              _c("div", [_vm._v("for " + _vm._s(_vm.totalPages))])
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a255d53", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a255d53","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/controls/Pagination.vue
// module id = null
// module chunks = 